/*******************************************************************************
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2016, 2020. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 *******************************************************************************/
'use strict';

var client = require('./client'),
  config = require('./config'),
  context = require('./context'),
  _ = require('lodash');
var CATEGORY = 'otc-ui';
var PRODUCT_TITLE = 'Continuous Delivery';
var DATA_ATTR_PREFIX = 'data-analytics-',
  DATA_ATTR_TRACK = DATA_ATTR_PREFIX + 'track';

/*
 * A centralized convenience module to access analytics. This is currently only available on the client,
 * but may support server later.
 */
if (client && config.SEGMENT_SOURCE_KEY) {
  // exclude metrics from UI tests and tolerate failure in analytics info population
  if (!hasCookie("ui-test") && window.analytics) {
    // identify current user only by IAM id (no personal info (PI) allowed in metrics)
    var user = context().user || context().userInfo;
    user && window.analytics.identify(user.iam_id);

    // global click listener for elements annotated to capture analytics data
    document.body.addEventListener('click', handleClick);
  }
}

/**
 * Track an event manually
 */
exports.track = function (type, props) {
  props = props || {};
  var baseProps = getBaseProps();
  for (var p in baseProps) {
    props[p] = baseProps[p];
  }
  var analytics = window.bluemixAnalytics;
  if (analytics && analytics.trackEvent) {
    analytics.trackEvent(type, props);
  }
};
function handleClick(evt) {
  // the click target may be inside an analytics element - find the closest analytics parent node
  var node = closestAnalyticsNode(evt.target);
  if (node && window.bluemixAnalytics) {
    var prefixLen = DATA_ATTR_PREFIX.length,
      attrs = node.attributes,
      props = getBaseProps(node);
    // find other data-analytics-* attributes and send them as properties
    for (var i = 0, len = attrs.length; i < len; ++i) {
      var attrName = attrs[i].name;
      if (attrName.substring(0, prefixLen) === DATA_ATTR_PREFIX && attrName !== DATA_ATTR_TRACK) {
        var propName = _.camelCase(attrName.substring(prefixLen));
        props[propName] = attrs[i].value;
      }
    }
    window.bluemixAnalytics.trackEvent('CTA Clicked', props);
  }
}

// Returns the basic set of props that should be included on every tracked event.
function getBaseProps(node) {
  var name = node && node.getAttribute(DATA_ATTR_TRACK);
  var props = {
    category: CATEGORY,
    pageName: getPageId(),
    productTitle: PRODUCT_TITLE
  };
  if (name) {
    props.CTA = 'Clicked: ' + name;
  }
  return props;
}
function getPageId() {
  return document.head.querySelector('[name=pageid]').content || 'unknown';
}
function closestAnalyticsNode(node) {
  if (node && node !== document) {
    // SVG elements don't have hasAttribute method in IE
    if (node.hasAttribute && node.hasAttribute(DATA_ATTR_TRACK)) {
      return node;
    }
    return closestAnalyticsNode(node.parentNode);
  }
}
function hasCookie(name) {
  var testStr = "; " + document.cookie;
  return testStr.indexOf('; ' + name + '=') !== -1;
}